import { render, staticRenderFns } from "./anamnese.vue?vue&type=template&id=787cd680&scoped=true"
import script from "./anamnese.vue?vue&type=script&lang=js"
export * from "./anamnese.vue?vue&type=script&lang=js"
import style0 from "./anamnese.vue?vue&type=style&index=0&id=787cd680&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787cd680",
  null
  
)

export default component.exports